export const CATEGORY_OPTIONS = [
  { label: 'Bug', value: 'bug' },
  { label: 'Billing', value: 'billing' },
  { label: 'Feature request', value: 'feature_request' },
  { label: 'How-to', value: 'how_to' },
  { label: 'Outage', value: 'outage' },
  { label: 'Performance', value: 'performance' },
  { label: 'Data', value: 'data' },
  { label: 'Other', value: 'other' }
];

export const SEVERITY_OPTIONS = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
  { label: 'Critical', value: 'critical' }
];

export const STATUS_OPTIONS = [
  { label: 'Open', value: 'open' },
  { label: 'Investigating', value: 'investigating' },
  { label: 'Resolved', value: 'resolved' },
  { label: 'Closed', value: 'closed' }
];

export const labelFor = (options, value) =>
  options.find((option) => option.value === value)?.label || value || '—';

export const SEVERITY_CLASS = {
  low: 'severityLow',
  medium: 'severityMedium',
  high: 'severityHigh',
  critical: 'severityCritical'
};

export const STATUS_CLASS = {
  open: 'statusOpen',
  investigating: 'statusInvestigating',
  resolved: 'statusResolved',
  closed: 'statusClosed'
};
